export default "__VITE_ASSET__Dss$4ERj__"